import ModalItens from './ModalItens';

export default class ModalItensElaborador extends ModalItens {

}
